import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageService } from "../storage/storage.service";
import { Observable, Subject } from "rxjs";

@Injectable()
export class BaseHttpService {

  constructor(
    protected _http: HttpClient,
    protected _storage: StorageService,
  ) {}

  get<T>(
    url: string,
    options?: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
      observe?: any;
      params?:
        | HttpParams
        | {
            [param: string]: string | string[];
          };
      reportProgress?: boolean;
      responseType?: any;
      withCredentials?: boolean;
    }
  ): Observable<T> {
    if (typeof Worker !== "undefined") {
      const currentUser = this._storage.get("currentUser");
      const geotikToken = this._storage.get("geotikRefreshToken");

      const result = new Subject<T>();
      // Create a new
      const worker = new Worker(new URL("./api.worker", import.meta.url), {
        type: "module",
      });
      worker.onmessage = ({ data }) => {
        if (data) {
          if (data.status === 200) {
            result.next(data?.data);
          } else {
            result.error(data?.data);
          }
          worker.terminate();
        }
      };
      worker.postMessage({
        method: "GET",
        url: url,
        accessToken: currentUser?.accessToken,
        geotikToken: geotikToken,
        options: options,
        language: currentUser?.language,
      });
      return result
        .asObservable()
    } else {
      return this._http
        .get<T>(url, options)
    }
  }
}
